import { callEmbeddedAgent } from "./callEmbeddedAgent-ffwEeqdP.js";
import { createDatasetFieldsTool } from "./dataset-fields-CBauoBBr.js";
import { createWhoamiTool } from "./whoami-DU_KhHDm.js";
import { systemPrompt } from "./config-lLg5qzu0.js";
import { z } from "zod";

//#region src/tools/support/search-issues/agent.ts
const searchIssuesAgentOutputSchema = z.object({
	query: z.string().describe("The Sentry issue search query"),
	sort: z.enum([
		"date",
		"freq",
		"new",
		"user",
		"recommended"
	]).nullable().describe("How to sort the results"),
	explanation: z.string().default("").describe("Brief explanation of how you translated this query.")
});
/**
* Search issues agent - single entry point for translating natural language queries to Sentry issue search syntax
* This returns both the translated query result AND the tool calls made by the agent
*/
async function searchIssuesAgent(options) {
	return await callEmbeddedAgent({
		system: systemPrompt,
		prompt: options.query,
		tools: {
			issueFields: createDatasetFieldsTool({
				apiService: options.apiService,
				organizationSlug: options.organizationSlug,
				dataset: "search_issues",
				projectId: options.projectId
			}),
			whoami: createWhoamiTool({ apiService: options.apiService })
		},
		schema: searchIssuesAgentOutputSchema
	});
}

//#endregion
export { searchIssuesAgent, searchIssuesAgentOutputSchema };
//# sourceMappingURL=agent-BIAUd2t1.js.map